<template>
  <slice :id="block._key" class="block-reassurance container" @in="onScreen">
    <lazy-image
      v-if="image"
      :image="image"
      provider="sanity"
      sizes="480w"
      :widths="[240, 480, 960]"
      class="flex-grow-1"
    />

    <div v-if="text" class="block-text">
      <portable-text :blocks="text" class="block-text__text" />
    </div>
  </slice>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

import Slice from '@/components/Slices/Slice'
import LazyImage from '@/components/Image/LazyImage'
import PortableText from '@/components/RichText/PortableText'

import { getSanityBunnyImageLink } from '~/utils/image'

export default {
  name: 'BlockReassurance',
  components: {
    Slice,
    LazyImage,
    PortableText,
  },
  props: {
    block: { type: Object, required: true },
  },
  computed: {
    ...mapGetters({
      globalLoading: 'global/loading',
      siteSettings: 'global/siteSettings',
    }),
    image() {
      if (this.block.override && this.block.image !== null) {
        return {
          url: getSanityBunnyImageLink(this.block.image, {
            width: 480,
            height: 640,
          }),
          dimensions: {
            width: 480,
            height: 640,
          },
        }
      }

      if (
        this.siteSettings &&
        this.siteSettings.default_reassurance &&
        this.siteSettings.default_reassurance.image
      ) {
        return {
          url: getSanityBunnyImageLink(
            this.siteSettings.default_reassurance.image,
            {
              width: 480,
              height: 640,
            }
          ),
          dimensions: {
            width: 480,
            height: 640,
          },
        }
      }
      return null
    },
    text() {
      if (this.block.override && this.block.text) {
        return this.block.text
      }

      if (
        this.siteSettings &&
        this.siteSettings.default_reassurance &&
        this.siteSettings.default_reassurance.text
      ) {
        return this.siteSettings.default_reassurance.text
      }
      return null
    },
  },
  methods: {
    ...mapActions({
      getSiteSettings: 'global/getSiteSettings',
    }),
    onScreen() {
      if (!this.siteSettings && !this.globalLoading) {
        this.getSiteSettings()
      }
    },
  },
}
</script>

<style lang="scss">
.block-reassurance {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: calc(var(--spacing) * 5.6) calc(var(--spacing) * 2);
  gap: var(--spacing);

  @include mq($from: tablet) {
    gap: calc(var(--spacing) * 2);
  }

  img {
    width: rem(120px);
    height: rem(120px);
  }

  .block-text {
    max-width: rem(480px);
  }
}
</style>
